import {borderRadius, buttonColors, fontsSize, plainColors, shadows} from "./UIElements/Elements";

const DashboardCard = ({title}) => {
    return (
        <div
            className={`max-lg:w-[92vw] max-lg:h-[13.5vh] w-[49.8vw] h-[30vh] flex items-center ${fontsSize.l} text-white cursor-pointer justify-center  ${buttonColors.secondary} ${borderRadius.medium}`}>
            {title}
        </div>
    );
}

export default DashboardCard;
